// Vendors
import './vendors/embla.js';

// Global
import './global/global.js';

// Utils
import animate from './utils/animate.js';

import './utils/customElsDrawer.js';
import './utils/customElsHeaderDrawer.js';
import './utils/product-form.js';
import './utils/customElsModal.js';
import './utils/customElsVideo.js';

// Sections
import './sections/accordion.js';
import './sections/embla-component.js';
import './sections/sticky-cart.js';
import './sections/desktop-menu.js';
import './sections/side-menu.js';
import './sections/free-shipping-bar.js';
import './sections/cart.js';

import './vendors/rellax.js';

// document.addEventListener('DOMContentLoaded', function () {
//   animate().init();
// });
